module.exports = __webpack_public_path__ + "img/academy_strengths-sm.b6bcdc0a.png";